import { Suspense } from "react";
import { createHashRouter } from "react-router-dom";
import MobileLayout from "../../layouts/Mobile";
import { routes } from "./routes";
import { PageSizeLoader } from "../../components/CustomComponents/PageSizeLoader";
import { AppErrorBoundary } from "../../components/CustomComponents/PageErrorBoundry";
import { ErrorComponent } from "../../components/CustomComponents/PageErrorBoundry/ErrorComponent";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { HomeHealthRouteGuard } from "./HomeHealthRouteGuard";

/** Flags gating access to beta-only routes. When a flag is ``false``
 *  the corresponding route entry is dropped from the router tree
 *  entirely — unlike a ``<Navigate>`` redirect on the component,
 *  this means a user typing e.g. ``/#/neo`` falls through to
 *  ``redirectElementStar``: no lazy chunk is fetched, no placeholder
 *  page is rendered, and there's no evidence the route exists. */
export interface MobileRouterFlags {
  hasNeoAccess: boolean;
}

export const mobileRouter = (
  connectionStatus: boolean,
  flags: MobileRouterFlags
) =>
  createHashRouter([
    {
      path: "/",
      element: <MobileLayout />,
      children: Object.entries(routes)
        .filter(([key]) => {
          if (key === "neo") return flags.hasNeoAccess;
          return true;
        })
        .map(([_, route]) => ({
          ...route,
          element: (
            <AppErrorBoundary
              FallbackComponent={({ error, resetErrorBoundary }) => (
                <ErrorComponent
                  error={error}
                  resetErrorBoundary={resetErrorBoundary}
                  connectionStatus={connectionStatus}
                />
              )}
              resetKeys={[route.path]}
            >
              <Suspense
                fallback={
                  <PageSizeLoader
                    loader={
                      <Spin
                        indicator={
                          <LoadingOutlined
                            style={{ fontSize: 48, color: "#161646" }}
                            spin
                          />
                        }
                      />
                    }
                  />
                }
              >
                <HomeHealthRouteGuard>
                  <route.element />
                </HomeHealthRouteGuard>
              </Suspense>
            </AppErrorBoundary>
          ),
        })),
    },
  ]);
